import { DsTableHeader } from '@alarislabs/angular-components/table';
import { Injectable, signal } from '@angular/core';
import { MnpFieldsService } from '@helpers/types/table/mnp-fields';

@Injectable({
	providedIn: 'root',
})
export class AiRulesFieldsService implements MnpFieldsService {
	readonly id: DsTableHeader = {
		name: 'ai_rules.id',
		variable: 'id',
	};
	readonly name: DsTableHeader = {
		name: 'ai_rules.name',
		variable: 'name',
	};
	readonly choiceList: DsTableHeader = {
		name: 'ai_rules.choice_list',
		variable: 'choiceList',
	};
	readonly prefixList: DsTableHeader = {
		name: 'ai_rules.prefix_list',
		variable: 'prefixList',
	};
	readonly productList: DsTableHeader = {
		name: 'ai_rules.client_product',
		variable: 'productList',
	};

	readonly headers: DsTableHeader[] = [this.id, this.name, this.choiceList, this.prefixList, this.productList];
	readonly tHeaders = signal(this.headers);
}
